<script setup>
// NOTICE: KAPTION-INTEGRATION — security-center.UI.3: a "Próximamente" card
import { useI18n } from 'vue-i18n';

defineProps({
  icon: { type: String, default: 'i-lucide-lock' },
  title: { type: String, required: true },
  description: { type: String, default: '' },
});
const { t } = useI18n();
</script>

<template>
  <div class="flex gap-3 p-4 border border-dashed rounded-xl border-n-strong">
    <span
      class="mt-0.5 size-4 shrink-0 text-n-slate-10"
      :class="icon"
      aria-hidden="true"
    />
    <div class="flex flex-col gap-1">
      <span
        class="flex flex-wrap items-center gap-2 text-sm font-semibold text-n-slate-12"
      >
        {{ title }}
        <span
          class="px-1.5 py-0.5 text-xs font-normal rounded-full bg-n-alpha-2 text-n-slate-11"
        >
          {{ t('KAPTION_SECURITY.COMMON.SOON') }}
        </span>
      </span>
      <span class="text-sm text-n-slate-11">{{ description }}</span>
    </div>
  </div>
</template>
